import { Link } from "react-router-dom";
import { gossipCategories, gossipList } from "@/mocks/gossipList";

const descriptions: Record<string, string> = {
  恋情绯闻: "同框、同款、同行程，三条线索各自都说明不了什么，叠加起来才成了话题。",
  剧组风波: "从通告单到戏份比例，剧组里最容易被放大的往往是流程本身。",
  合约解约: "合约节点前后最容易出现信息真空，而空窗期正是传闻的温床。",
  舞台争议: "现场听感、舞台设备、演出排期，技术问题常常被讲成人品问题。",
  商业代言: "物料下架时间被当成信号，一个正常的商务变动能长出三种版本。",
  形象争议: "旧内容被翻出来重新解读，考验的是回应的速度和材料的可验证性。",
  综艺名场面: "一句台词、一次救场，往往是整季节目传播最广的内容。",
};

export default function CategorySection() {
  const cats = gossipCategories.slice(1);

  return (
    <section id="categories" className="w-full bg-background-50" aria-labelledby="categories-title">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs text-secondary-700 mb-2">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-folders-line"></i>
              </span>
              CATEGORIES
            </p>
            <h2 id="categories-title" className="font-heading font-black text-2xl md:text-3xl text-foreground-950">
              按主题找瓜，比按热度找更快
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              30 条事件被归到 7 个主题里。如果你只关心某一类，直接从分类进入会省掉大量筛选时间。
            </p>
          </div>
          <Link
            to="/rankings"
            className="self-start md:self-auto flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            浏览全部条目
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {cats.map((c, index) => {
            const count = gossipList.filter((g) => g.category === c.key).length;
            const featured = index === 0;
            return (
              <Link
                key={c.key}
                to={`/rankings?category=${encodeURIComponent(c.key)}`}
                className={`group flex flex-col gap-3 rounded-lg p-5 border transition-colors cursor-pointer ${
                  featured
                    ? "bg-primary-900 border-primary-900 hover:border-accent-500"
                    : "bg-background-100 border-background-200 hover:border-primary-300"
                }`}
              >
                <div className="flex items-start justify-between gap-3">
                  <span
                    className={`w-11 h-11 flex items-center justify-center rounded-md ${
                      featured ? "bg-accent-500 text-primary-950" : "bg-secondary-100 text-secondary-700 group-hover:bg-accent-100 group-hover:text-accent-800"
                    } transition-colors`}
                  >
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <span
                    className={`text-xs px-2 py-0.5 rounded-full ${
                      featured ? "bg-primary-800 text-primary-100" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    {count} 条
                  </span>
                </div>
                <h3
                  className={`font-heading font-bold text-base md:text-lg ${
                    featured ? "text-background-50" : "text-foreground-950 group-hover:text-primary-700"
                  } transition-colors`}
                >
                  {c.label}
                </h3>
                <p className={`text-sm leading-relaxed ${featured ? "text-primary-200" : "text-foreground-600"}`}>
                  {descriptions[c.key]}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}